import { Droppable } from "@/components/dnd/Droppable";
import { SortableRect } from "@/components/DeckBuilder/SortableRect";
import DeckStats from "@/components/Decklists/DeckStats";
import { getCardData } from "@/lib/games/onePiece/getCardDataLocal";
import { useSetCardOrderIds } from "@/stores/deckStore";

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";

export default function Stats({
  deck,
  getCount,
}: {
  deck: any;
  getCount: any;
}) {
  const setCardOrderIds = useSetCardOrderIds();
  const sensors = useSensors(
    // useSensor(PointerSensor, {
    //   activationConstraint: {
    //     distance: 1,
    //   },
    // }),
    useSensor(TouchSensor, {}),
    // useSensor(KeyboardSensor, {
    //   coordinateGetter: sortableKeyboardCoordinates,
    // }),
  );

  function handleDragEnd(event: any) {
    console.log("handleDragEnd DeckLayoutBottom");
    const { active, over } = event;

    if (active.id !== over.id) {
      console.log("activeid", active.id, "overid", over.id);
      setCardOrderIds((prevCardOrderIds: string[]) => {
        // const oldIndex = items.findIndex((x) => {
        //   return x.order;
        // });
        const oldIndex = prevCardOrderIds.indexOf(active.id);
        const newIndex = prevCardOrderIds.indexOf(over.id);

        return arrayMove(prevCardOrderIds, oldIndex, newIndex);
      });
    }
  }

  let leaderData;
  let leader = deck.getLeaderId();
  if (leader) {
    leaderData = getCardData(leader);
    console.log(leaderData);
  }

  return (
    <div>
      <div
        className="overflow-scroll px-4"
        style={{
          height: "calc(100svh - 88px - 44px - 8px - 8px)",
          minHeight: "120px",
        }}
      >
        {getCount() === 0 ? (
          <div className="h-full w-full flex justify-center items-center italic">
            No cards in deck
          </div>
        ) : (
          <div className="pb-2">
            <DeckStats
              leaderLife={leaderData?.life || 5}
              decklist={deck.getDecklist()}
            />
          </div>
        )}
      </div>
    </div>
  );
}
